import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { Editor } from "@tinymce/tinymce-react";
import Switch from "react-switch";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Editjob = () => {
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const id = useParams();
  let token = localStorage.getItem("accessToken");
  let val;
  const [checked, setChecked] = useState(false);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const fetchJobdata = () => {
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-joblisting-byid",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id.jobId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setData(response.data.data[0]);
        setChecked(response.data.data[0].status == 1 ? true : false);
        setDescription(response.data.data[0].description);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const onSubmit = async (getData) => {
    setLoading(true);
    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "admin/update-jobopeing",
        data: {
          id: id.jobId,
          title: getData.tittle,
          employmentType: getData.employment,
          email: getData.email,
          datePosted: getData.startDate,
          validThrough: getData.endDate,
          description: description,
          location: getData?.location,
          experience: getData?.experince,
          status: checked === true ? 1 : 0,
        },
        headers: {
          "Content-type": "application/json",
          "x-access-token": token,
        },
      });

      if (res.data.status === true) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/career");
      }
    } catch (error) {
      setLoading(false);
      if (error.response !== "" && error.response.data.message !== "") {
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  const handleChange = (checked) => {
    setChecked(checked);
  };

  useEffect(() => {
    fetchJobdata();
  }, []);

  useEffect(() => {
    if (data) {
      setValue("tittle", data?.title);
      setValue("employment", data?.employmentType);
      setValue("startDate", data?.datePosted);
      setValue("endDate", data?.validThrough);
      setValue("email", data?.email);
      setValue("description", data?.description);
      setValue("experince", data?.experience);
      setValue("location", data?.location);
    }
  }, [data]);

  const disablePastDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit Job</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div"></div>
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>Job Title</label>
                <input
                  type="text"
                  name="tittle"
                  {...register("tittle", {
                    required: "Title is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Job Tittle"
                />
                {errors.tittle && (
                  <div className="invalid-feedback">
                    {errors.tittle.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Employment Type</label>
                <input
                  type="text"
                  name="employment"
                  {...register("employment", {
                    required: "Employment type is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Employment Type"
                />
                {errors.employment && (
                  <div className="invalid-feedback">
                    {errors.employment.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Job Location</label>
                <input
                  type="text"
                  name="location"
                  {...register("location", {
                    required: "Title is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Job Location"
                />
                {errors.location && (
                  <div className="invalid-feedback">
                    {errors.location.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Experience</label>
                <input
                  type="text"
                  name="experince"
                  {...register("experince", {
                    required: "Title is required",
                    pattern: {
                      value: /^[A-Za-z0-9 _]+$/,
                      message: "Please enter a valid experince",
                    },
                  })}
                  placeholder="Enter Experince"
                />
                {errors.experince && (
                  <div className="invalid-feedback">
                    {errors.experince.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  min={disablePastDate()}
                  {...register("startDate", {
                    required: "Start Date is required",
                  })}
                  placeholder="Enter Start Date"
                />
                {errors.startDate && (
                  <div className="invalid-feedback">
                    {errors.startDate.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>End Date</label>
                <input
                  type="date"
                  name="endDate"
                  {...register("endDate")}
                  min={disablePastDate()}
                  placeholder="Enter End Date"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              <div className="formInput">
                <label>Status</label>
                <Switch
                  onChange={handleChange}
                  checked={checked == 1 ? true : false}
                />
              </div>
              <div className="formInputDescription">
                <label>Job Description</label>

                <Editor
                  textareaName="description"
                  initialValue={data.description}
                  name="description"
                  apiKey="4xerbueqmh9h3gt7gkvu7xnlqgntlyv3qlqtcx6kr7du2cl2"
                  init={{
                    selector: "textarea",
                    height: 300,
                    menubar: true,
                    toolbar: "bottom",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "lists",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  onEditorChange={(newText) => setDescription(newText)}
                />
              </div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editjob;
